// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__LZHl1","card":"Contact_card__40qqw","card2":"Contact_card2__WUPc2","icons":"Contact_icons__npVUS","section":"Contact_section__Nydb9"};